<template>
  <div id="planInfoContainer">
    <div id="img-container">
      <div id="img-plan" class="img-plan">
        <h3 id="img-plan-title">Pré-pago Manual</h3>
        <h3 id="img-plan-subtitle">Pessoa Jurídica</h3>
        <div></div>
        <h5 @click="abrirModal()">Tabela de recarga</h5>
      </div>
    </div>
    <div id="card-info-container">
      <div class="info-desc-container">
        <img src="./checkmark.svg" />
        <p id="detalhe1"></p>
      </div>
      <div class="info-desc-container">
        <img src="./checkmark.svg" />
        <p id="detalhe2"></p>
      </div>
      <div class="info-desc-container">
        <img src="./checkmark.svg" />
        <p id="detalhe3"></p>
      </div>
      <div class="info-desc-container">
        <img src="./checkmark.svg" />
        <p id="detalhe4"></p>
      </div>
      <div class="info-desc-container">
        <img src="./checkmark.svg" />
        <p id="detalhe5"></p>
      </div>
      <div class="info-desc-container">
        <img src="./checkmark.svg" />
        <p id="detalhe6"></p>
      </div>
      <a :href="roadCardPJ">
        <div id="plan-button">
          <p>Quero este plano</p>
          <img src="./angle-right.svg" />
        </div>
      </a>
    </div>
    <div v-if="showModal" class="modalContainer">
      <ModalRechargePj @fechar-modal="fecharModal"></ModalRechargePj>
      <div class="overlay" v-if="showModal"></div>

      <!-- <div class="backGroundContainerModal"></div> -->
    </div>
  </div>
</template>
<script>
import ModalRechargePj from "../../modal/modalRechargesPj.vue";
// const config = require("../../../../../../../static/roadcardConfig.js");
import contract from "../../../../../../services/contracts";

export default {
  components: {
    ModalRechargePj,
  },
  data() {
    return {
      roadCardPJ: undefined,
      showModal: false, // Variável para controlar a visibilidade do modal
      detalhe1: undefined,
      detalhe2: undefined,
      detalhe3: undefined,
      detalhe4: undefined,
      detalhe5: undefined,
      detalhe6: undefined,
    };
  },

  mounted() {
    contract.getRechargesRoadcard(71).then((res) => {
      this.detalhe1 = res.plano.detalhes[0];
      this.detalhe2 = res.plano.detalhes[1];
      this.detalhe3 = res.plano.detalhes[2];
      this.detalhe4 = res.plano.detalhes[3];
      this.detalhe5 = res.plano.detalhes[4];
      this.detalhe6 = res.plano.detalhes[5];

      console.log("detalhe4", this.detalhe4);
      console.log("detalhe5", this.detalhe5);

      const detalhe1 = document.getElementById("detalhe1");
      detalhe1.innerHTML = this.detalhe1;

      const detalhe2 = document.getElementById("detalhe2");
      detalhe2.innerHTML = this.detalhe2;

      const detalhe3 = document.getElementById("detalhe3");
      detalhe3.innerHTML = this.detalhe3;

      const detalhe4 = document.getElementById("detalhe4");
      detalhe4.innerHTML = this.detalhe4;

      const detalhe5 = document.getElementById("detalhe5");
      detalhe5.innerHTML = this.detalhe5;

      const detalhe6 = document.getElementById("detalhe6");
      detalhe6.innerHTML = this.detalhe6;
    });
    this.getRoadCardUrl();
  },
  methods: {
    getRoadCardUrl() {
      contract.getGeneralParameter("URL_ATHENA_PJ").then((res) => {
        this.roadCardPJ = res.value;
      });
    },
    abrirModal() {
      this.showModal = true;
      document.body.style.overflow = "hidden";
    },
    fecharModal() {
      this.showModal = false; // Fecha a modal quando o evento é capturado
      document.body.style.overflow = "";
    },
  },
};
</script>
<style lang="css">
html,
body {
  overflow-x: hidden;
}
.backGroundContainerModal {
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}
.modalContainer {
  display: flex;
  min-height: 100vw;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  align-items: center;
  justify-content: center;
}
#plan-button {
  padding: 1.5rem 2rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #5d3b81;
  color: #fff;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 1rem;
}
#plan-button p {
  margin: 0;
}
#card-info-container {
  display: flex;
  flex-direction: column;
  padding: 3rem;
}
.info-desc-container {
  display: flex;
}
.info-desc-container p {
  color: #1a293dd4;
}
.info-desc-container p span {
  font-weight: bold;
}
.info-desc-container img {
  margin-right: 1.5rem;
}

.img-plan {
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.img-plan h5 {
  margin: 1rem 0 0 0;
  text-decoration: underline;
  cursor: pointer;
}
#img-plan-title {
  font-weight: bold;
  margin: 0;
}
#img-plan-subtitle {
  margin: 1rem 0 0 0;
}
#planInfoContainer {
  display: flex;
  flex-direction: column;
  border: solid 1px #e0dedd;
  border-radius: 8px;
  width: 45%;
  display: flex;
  padding: 0.1rem;
}
#img-plan {
  border-radius: 8px;
  background-image: url("./rectangleViolet.svg");
  width: 100%;
  height: 19rem;
  background-size: cover;
  background-repeat: no-repeat;
  aspect-ratio: 1 / 1;
}

#img-container {
  padding-bottom: 0.1rem;
  border-bottom: solid 1px #f6f4f3;
}

@media (max-width: 600px) {
  #planInfoContainer {
    width: 80vw;
    margin-top: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// planInfo.vue?04954c62